import { asyncRouterMap, constantRouterMap } from "@/router/index";

//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    // console.log("hasPermission", route.name, currMenu);
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.permissionDesc != null && currMenu.permissionDesc !== "") {
        route.meta.title = currMenu.permissionDesc;
      } else if (currMenu.title != null && currMenu.title !== "") {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== "") {
        route.meta.icon = currMenu.icon;
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== "") {
        route.sort = currMenu.sort;
      }
      return currMenu;
    } else {
      // route.sort = 0;
      // if (route.hidden !== undefined && route.hidden === true) {
      //   route.sort = -1;
      //   return true;
      // } else {
      //   return false;
      // }
      return null;
    }
  } else {
    return null;
  }
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.preAuthorize) {
      return menu;
    }
  }
  return null;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, menus) {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    const menu = hasPermission(menus, tmp);
    if (menu) {
      if (tmp.children && menu.permissionList) {
        tmp.children = filterAsyncRoutes(tmp.children, menu.permissionList);
      }
      res.push(tmp);
    }
  });

  return res;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if (router.permissionList && router.permissionList.length > 0) {
      router.permissionList.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p) {
  return function(m, n) {
    let a = m[p];
    let b = n[p];
    return b - a;
  };
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const accessedRouters = filterAsyncRoutes(asyncRouterMap, menus);
        // console.log("GenerateRoutes >> accessedRouters >> ", accessedRouters);
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    }
  }
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js